import { Component, OnInit } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService } from 'app/services/data.service';

@Component({
  selector: 'app-confirm-inspection-dialogue',
  templateUrl: './confirm-inspection-dialogue.component.html',
  styleUrls: ['./confirm-inspection-dialogue.component.scss'],
  providers: [DialogService],
})
export class ConfirmInspectionDialogueComponent implements OnInit {
  data: any = {};

  constructor(private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dataService: DataService) {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
  }

  closeAttendenceModal(data: any) {
    this.dynamicDialogRef.close(data);
  }

  closeDialog(isSuccess: boolean, btn = '') {
    this.data.btn = btn;
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.dynamicDialogRef.close({ isSuccess, data: this.data });
  }
}
